export function SubmissionCard({ record, type }) {
  const isQuote = type === "quotes";
  return (
    <article className="border border-[hsl(var(--lh-bone))]/15 bg-[hsl(var(--lh-ink-2))] p-6" data-testid={`admin-row-${record.id}`}>
      <div className="flex flex-wrap justify-between gap-2 mb-4">
        <div className="font-display text-xl">{record.name}</div>
        <div className="font-mono text-xs text-[hsl(var(--lh-bone))]/50">
          {new Date(record.created_at).toLocaleString()}
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-4 text-sm">
        <div><span className="lh-label">Email</span>{record.email}</div>
        <div><span className="lh-label">Phone</span>{record.phone}</div>
        {isQuote ? (
          <div><span className="lh-label">Service</span>{record.service}</div>
        ) : (
          <div><span className="lh-label">Role</span>{record.role}</div>
        )}
      </div>
      {isQuote ? (
        <div className="mt-4">
          <span className="lh-label">Details</span>
          <p className="text-[hsl(var(--lh-bone))]/85 whitespace-pre-wrap">{record.details}</p>
        </div>
      ) : (
        <div className="mt-4 grid md:grid-cols-3 gap-4 text-sm">
          <div><span className="lh-label">CDL</span>{record.cdl_class || "—"}</div>
          <div><span className="lh-label">Experience</span>{record.experience_years || "—"} yrs</div>
          <div className="md:col-span-3">
            <span className="lh-label">Notes</span>
            <p className="text-[hsl(var(--lh-bone))]/85 whitespace-pre-wrap">{record.notes || "—"}</p>
          </div>
        </div>
      )}
    </article>
  );
}
